import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Divider, Tab } from '@mui/material';
import { DepartmentsProvider } from 'context/departments-context';
import { WorkflowStepsProvider } from 'context/workflow-steps-context';
import ProductionValueTemplates from './production-value-templates/production-value-templates';
import ProductionValueSteps from 'components/lab-settings/production-workflow-settings/production-value-steps/production-value-steps';

const ProductionValueSettings: FC = () => {
    const { t: translate } = useTranslation(['lab-settings']);
    const [tabState, setTabState] = React.useState('production-value-steps');

    return (
        <TabContext value={tabState}>
            <Box mb={1}>
                <TabList onChange={(_, value) => setTabState(value)}>
                    <Tab label={translate('lab-settings:PRODUCTION_VALUE_STEPS')} value="production-value-steps" />
                    <Tab
                        label={translate('lab-settings:PRODUCTION_VALUE_TEMPLATES')}
                        value="production-value-templates"
                    />
                </TabList>
            </Box>
            <Box mb={3}>
                <Divider />
            </Box>
            <DepartmentsProvider>
                <TabPanel sx={{ padding: 0 }} value="production-value-steps">
                    <WorkflowStepsProvider>
                        <ProductionValueSteps />
                    </WorkflowStepsProvider>
                </TabPanel>
                <TabPanel sx={{ padding: 0 }} value="production-value-templates">
                    <ProductionValueTemplates />
                </TabPanel>
            </DepartmentsProvider>
        </TabContext>
    );
};

export default ProductionValueSettings;
